(() => {
  if (window.__grattiStorefrontReady) return;
  window.__grattiStorefrontReady = true;

  const root = () => window.Shopify?.routes?.root || '/';
  const drawer = () => document.getElementById('gs-cart-drawer');

  const money = (cents, currency) => new Intl.NumberFormat('es-CL', {
    style: 'currency',
    currency: currency || 'CLP',
    maximumFractionDigits: 0
  }).format((cents || 0) / 100);

  const closeCart = () => {
    const cartDrawer = drawer();
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gs-cart-open');
  };

  const renderCart = (cart) => {
    const cartDrawer = drawer();
    if (!cartDrawer) return;
    const itemsContainer = cartDrawer.querySelector('[data-gs-cart-items]');
    const footer = cartDrawer.querySelector('[data-gs-cart-footer]');
    const total = cartDrawer.querySelector('[data-gs-cart-total]');

    document.querySelectorAll('[data-gs-cart-count]').forEach((badge) => {
      badge.textContent = cart.item_count;
      badge.classList.toggle('is-empty', cart.item_count === 0);
    });
    itemsContainer.replaceChildren();

    if (!cart.items.length) {
      const empty = document.createElement('p');
      empty.className = 'gs-cart-drawer__empty';
      empty.textContent = 'Tu carrito está vacío.';
      itemsContainer.appendChild(empty);
      footer.hidden = true;
      return;
    }

    cart.items.forEach((item) => {
      const row = document.createElement('article');
      row.className = 'gs-cart-item';
      if (item.image) {
        const image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title;
        image.width = 104;
        image.height = 104;
        row.appendChild(image);
      }

      const copy = document.createElement('div');
      copy.className = 'gs-cart-item__copy';
      const title = document.createElement('a');
      title.href = item.url;
      title.textContent = item.product_title;
      copy.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        const variant = document.createElement('p');
        variant.textContent = item.variant_title;
        copy.appendChild(variant);
      }

      const meta = document.createElement('div');
      meta.className = 'gs-cart-item__meta';
      const quantity = document.createElement('span');
      quantity.textContent = `Cant. ${item.quantity}`;
      const price = document.createElement('strong');
      price.textContent = money(item.final_line_price, cart.currency);
      meta.append(quantity, price);
      copy.appendChild(meta);
      row.appendChild(copy);
      itemsContainer.appendChild(row);
    });

    total.textContent = money(cart.total_price, cart.currency);
    footer.hidden = false;
  };

  window.gsOpenCart = async () => {
    const cartDrawer = drawer();
    if (!cartDrawer) return;
    const itemsContainer = cartDrawer.querySelector('[data-gs-cart-items]');
    const footer = cartDrawer.querySelector('[data-gs-cart-footer]');
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('gs-cart-open');

    try {
      const response = await fetch(`${root()}cart.js`, { headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('No se pudo cargar el carrito');
      renderCart(await response.json());
      cartDrawer.querySelector('.gs-cart-drawer__close')?.focus();
    } catch (error) {
      itemsContainer.textContent = 'No pudimos cargar el carrito. Inténtalo nuevamente.';
      footer.hidden = true;
    }
  };

  const updateVariant = (select) => {
    const product = select.closest('.gs-pdp');
    if (!product) return;
    const option = select.options[select.selectedIndex];
    const price = product.querySelector('.gs-pdp__price');
    const image = product.querySelector('.gs-gallery__item img');
    const label = product.querySelector('.gs-variant-picker legend span');
    const thumbs = Array.from(product.querySelectorAll('.gs-variant-thumb'));
    if (price) {
      price.replaceChildren();
      if (option.dataset.compare) {
        const compare = document.createElement('s');
        compare.textContent = option.dataset.compare;
        price.append(compare, document.createTextNode(' '));
      }
      const current = document.createElement('span');
      current.textContent = option.dataset.price;
      price.appendChild(current);
    }
    const activeThumb = thumbs.find((thumb) => thumb.dataset.variantId === select.value)
      || thumbs.find((thumb) => thumb.dataset.mediaId === option.dataset.mediaId);
    thumbs.forEach((thumb) => {
      const selected = thumb === activeThumb;
      thumb.classList.toggle('is-selected', selected);
      thumb.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    if (activeThumb) {
      if (label) label.textContent = activeThumb.dataset.title;
      if (image && activeThumb.dataset.image) {
        image.src = activeThumb.dataset.image;
        image.removeAttribute('srcset');
        image.alt = activeThumb.dataset.title;
      }
    }
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('.gs-cart-trigger')) {
      event.preventDefault();
      window.gsOpenCart();
      return;
    }
    if (event.target.closest('[data-gs-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }
    const thumb = event.target.closest('.gs-variant-thumb');
    if (thumb) {
      const product = thumb.closest('.gs-pdp');
      const select = product?.querySelector('select[id^="gs-variant-"]');
      if (select) {
        select.value = thumb.dataset.variantId;
        updateVariant(select);
      }
    }
  });

  document.addEventListener('change', (event) => {
    if (event.target.matches('select[id^="gs-variant-"]')) updateVariant(event.target);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('form[id^="gs-product-form-"]');
    if (!form) return;
    event.preventDefault();
    const addButton = form.querySelector('.gs-pdp__add');
    if (!addButton || form.dataset.submitting === 'true') return;

    form.dataset.submitting = 'true';
    const originalLabel = addButton.textContent;
    addButton.disabled = true;
    addButton.textContent = 'Agregando…';
    try {
      const response = await fetch(`${root()}cart/add.js`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || result.message || 'No se pudo agregar este producto');
      addButton.textContent = 'Agregado';
      await window.gsOpenCart();
    } catch (error) {
      addButton.textContent = error.message || 'Inténtalo nuevamente';
    } finally {
      window.setTimeout(() => {
        addButton.textContent = originalLabel;
        addButton.disabled = false;
        form.dataset.submitting = 'false';
      }, 1200);
    }
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && drawer()?.classList.contains('is-open')) closeCart();
  });

  document.querySelectorAll('select[id^="gs-variant-"]').forEach(updateVariant);
})();

